import { ArrowUp } from 'lucide-react'
import { useT } from '@/i18n'

interface Props {
  count: number
  onClick: () => void
}

export function NewPostsBanner({ count, onClick }: Props) {
  const t = useT()
  if (count <= 0) return null
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full border-b border-line py-3 text-[15px] font-bold text-brand-ink hover:bg-surface-hover"
    >
      <span className="inline-flex items-center gap-2">
        <ArrowUp className="size-4" />
        {t('timeline.newPosts', { count })}
      </span>
    </button>
  )
}
